import api from "./api";

// Política de historial por conexión API Baileys (doc 0439 S1/S6).
export const getBaileysSyncPolicy = (whatsAppId) => api.get(`/baileys/connections/${whatsAppId}/sync-policy`);
export const saveBaileysSyncPolicy = (whatsAppId, policy) =>
  api.put(`/baileys/connections/${whatsAppId}/sync-policy`, policy);
